import IconButton from '@mui/material/IconButton'
import { useTheme } from '@mui/material/styles'
import SvgIcon from '@mui/material/SvgIcon'
import Tooltip from '@mui/material/Tooltip'
import { Archive } from '@styled-icons/heroicons-outline/Archive'
import React, { useCallback } from 'react'

import T from 'T'

import StyledBadge from '../StyledBadge'

type ViewArchivedNotesActionProps = {
  onViewArchiveClick: () => void
  archivedNotes?: unknown[]
}

const ViewArchivedNotesAction: React.FC<ViewArchivedNotesActionProps> = ({ onViewArchiveClick, archivedNotes = [] }) => {
  const theme = useTheme()
  const hasArchivedNotes = archivedNotes.length > 0

  const handleViewArchiveClick = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation()
      if (hasArchivedNotes) {
        onViewArchiveClick()
      }
    },
    [hasArchivedNotes, onViewArchiveClick]
  )

  return hasArchivedNotes ? (
    <IconButton onClick={handleViewArchiveClick}>
      <StyledBadge badgeContent={archivedNotes.length}>
        <Archive height={24} width={24} />
      </StyledBadge>
    </IconButton>
  ) : (
    <Tooltip disableHoverListener={hasArchivedNotes} title={T.NO_ARCHIVED_NOTE_AVAILABLE}>
      <SvgIcon sx={{ cursor: 'default', m: 1 }} onClick={handleViewArchiveClick}>
        <Archive color={theme.palette.action.disabled} height={24} width={24} />
      </SvgIcon>
    </Tooltip>
  )
}

export default ViewArchivedNotesAction
